<ng-container *ngIf="!isLoginPage && !isLandingPage; else loginContent">
  <div class="min-h-screen flex flex-col bg-slate-50 text-gray-800 overflow-hidden">

    <!-- Header -->
    <app-header
      class="sticky top-0 z-40 w-full bg-white shadow-sm"
      (toggleSidebar)="toggleSidebar()"
      [sidebarMode]="sidebarMode"
      [isHovering]="isHovering"
      [showSubMenuTabs]="showSubMenuTabs"
      [activeMenuWithSubItems]="activeMenuWithSubItems"
      [activeMenu]="getActiveMenuName()"
      [subMenuItems]="getActiveSubMenuItems()"
      [currentSubMenu]="getCurrentSubMenu()"
      [activeMenuIcon]="getActiveMenuIcon()"
      (subMenuClick)="onSubMenuClick($event)">
    </app-header>

    <!-- Body below header -->
    <div class="relative min-h-[calc(100vh-64px)]">

      <!-- Sidebar -->
      <app-sidebar
        [sidebarMode]="sidebarMode"
        [isHovering]="isHovering"
        (hoverChange)="isHovering = $event"
        (toggleRequested)="toggleSidebar()"
        (menuWithSubItemsClicked)="onMenuWithSubItemsClicked($event)"
        (menuWithoutSubItemsClicked)="onMenuWithoutSubItemsClicked()"
        class="z-50">
      </app-sidebar>

      <!-- Main -->
      <main
        class="min-h-[calc(100vh-64px)] transition-all duration-300 ease-in-out"
        [ngClass]="getMainLayoutClass()">

        <div class="px-2 md:px-4 h-full">
          <div class="relative overflow-hidden rounded-md">

            <p-toast position="top-right"></p-toast>

            <!-- Back Button -->
            <button
              *ngIf="showBackButton"
              class="absolute top-[1%] right-[50%] bg-blue-600 hover:bg-blue-700 text-white rounded-full w-10 h-10 flex items-center justify-center shadow-lg z-20 transition-transform hover:scale-110"
              (click)="goBackToTileView()"
              pTooltip="Back to Grid View">

              <i class="pi pi-th-large"></i>
            </button>

            <!-- Loading Overlay -->
            <div
              *ngIf="loadingService.loading$ | async"
              class="absolute inset-0 bg-white/60 backdrop-blur-[2px] z-50 flex items-center justify-center">

              <p-progressSpinner strokeWidth="4"></p-progressSpinner>
            </div>

            <!-- Routed pages -->
            <router-outlet></router-outlet>

          </div>
        </div>

      </main>

    </div>

    <!-- ✅ Chatbot (Global floating component) -->
    <app-chatbox></app-chatbox>

  </div>
</ng-container>

<!-- Login / Landing -->
<ng-template #loginContent>
  <div class="min-h-screen bg-slate-50">
    <router-outlet></router-outlet>
    <p-toast position="top-right"></p-toast>
  </div>
</ng-template>


<!-- <app-chatbox></app-chatbox> -->
<!-- <app-dyn-tem-from [(visible)]="isUpdatedialog" [config]="updateDialogConfig" [initialData]="initialData"
  (onSubmit)="onSmitData($event)" [viewMode]="false"></app-dyn-tem-from> -->